import {header} from "./modules/header";
import {triggerModal} from "./modules/modal";
import {initLabel} from "./modules/floatlabel";
import {handleFormSubmit} from './modules/form';
import {animateLogo} from "./modules/animate-logo";
import {initAnim} from "./modules/animations";
import {initWcmlCurrencyA11y} from "./modules/wcml-currency-a11y";

document.addEventListener("DOMContentLoaded", function () {
  header().init()
  triggerModal()
  initLabel()
  animateLogo();
  handleFormSubmit().init();
  initAnim().init();
  initWcmlCurrencyA11y();
})
